import addGuestService from './services/guest.add.service';
import guestnameService from './services/guest.name.service';

let sharedGuestModule = angular.module('spabooker.shared.guest', [])
    .factory('addGuestService', addGuestService)
    .factory('guestnameService', guestnameService)
    ;

export default sharedGuestModule.name;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/shared/guest/index.js